(() => {
 if (window.acArtworksInitialized) return;
 window.acArtworksInitialized = true;
 const savedKey = 'ac-saved-artworks';
 const saved = () => { try { return JSON.parse(localStorage.getItem(savedKey) || '[]'); } catch { return []; } };
 const layout = root => {
  const grid = root.querySelector('[data-ac-grid]');
  if (!grid) return;
  const style = getComputedStyle(grid), row = parseFloat(style.gridAutoRows), gap = parseFloat(style.rowGap);
  grid.querySelectorAll('.ac-artwork-card').forEach(card => {
   card.style.gridRowEnd = 'auto';
   card.style.gridRowEnd = 'span ' + Math.ceil((card.getBoundingClientRect().height + gap) / (row + gap));
  });
 };
 const init = root => {
  if (root.dataset.acReady) return;
  root.dataset.acReady = 'true';
  const form = root.querySelector('[data-ac-filter-form]');
  form.dataset.acEnhanced = 'true';
  const close = () => { form.classList.remove('is-open'); root.querySelector('[data-ac-filter-open]').focus(); };
  root.querySelector('[data-ac-filter-open]').addEventListener('click', () => { form.classList.add('is-open'); form.querySelector('[data-ac-filter-close]').focus(); });
  form.querySelector('[data-ac-filter-close]').addEventListener('click', close);
  form.addEventListener('keydown', event => {
   if (event.key === 'Escape') close();
   if (event.key === 'Tab' && form.classList.contains('is-open')) {
    const nodes = [...form.querySelectorAll('button,input,select')].filter(n => !n.disabled && getComputedStyle(n).display !== 'none');
    if (event.shiftKey && document.activeElement === nodes[0]) { event.preventDefault(); nodes.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === nodes.at(-1)) { event.preventDefault(); nodes[0].focus(); }
   }
  });
  form.addEventListener('submit', event => {
   event.preventDefault();
   const url = new URL(form.action);
   url.search = new URLSearchParams(new FormData(form)).toString();
   const preview = new URL(location.href).searchParams.get('preview_theme_id');
   if (preview) url.searchParams.set('preview_theme_id', preview);
   location.assign(url);
  });
  form.addEventListener('change', event => {
   if (event.target.matches('input[type=checkbox],select[name=sort_by]') && matchMedia('(min-width:750px)').matches) form.requestSubmit();
  });
  const refreshSaved = () => root.querySelectorAll('[data-ac-save]').forEach(button => button.setAttribute('aria-pressed', String(saved().includes(button.dataset.acSave))));
  refreshSaved();
  root.addEventListener('click', async event => {
   const heart = event.target.closest('[data-ac-save]');
   if (heart) {
    const items = saved(), id = heart.dataset.acSave, next = items.includes(id) ? items.filter(x => x !== id) : [...items, id];
    try { localStorage.setItem(savedKey, JSON.stringify(next)); refreshSaved(); } catch { root.querySelector('[data-ac-load-status]').textContent = 'Saving is unavailable in this browser.'; }
   }
   const link = event.target.closest('[data-ac-load-more]');
   if (!link || link.getAttribute('aria-busy') === 'true') return;
   event.preventDefault(); link.setAttribute('aria-busy','true');
   const status = root.querySelector('[data-ac-load-status]');
   status.textContent = 'Loading artworks…';
   try {
    const url = new URL(link.href); url.searchParams.set('section_id', root.dataset.sectionId);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to load');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = doc.querySelector('[data-ac-artworks]');
    if (!next) throw new Error('Missing collection');
    const cards = next.querySelectorAll('.ac-artwork-card');
    if (!cards.length) throw new Error('No new artworks');
    root.querySelector('[data-ac-grid]').append(...cards);
    const nextLink = next.querySelector('[data-ac-load-more]');
    if (nextLink) { link.href = nextLink.href; link.removeAttribute('aria-busy'); } else link.remove();
    refreshSaved(); layout(root);
    status.textContent = cards.length + ' more artworks loaded.';
   } catch { link.removeAttribute('aria-busy'); status.textContent = 'Unable to load artworks. Please try again.'; }
  });
  root.addEventListener('load', () => layout(root), true);
  new ResizeObserver(() => layout(root)).observe(root.querySelector('[data-ac-grid]'));
  document.fonts.ready.then(() => layout(root));
  layout(root);
 };
 const start = () => document.querySelectorAll('[data-ac-artworks]').forEach(init);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
 document.addEventListener('shopify:section:load', start);
})();
